import { useTranslation } from 'react-i18next';

const SectionFinalCTA = () => {
    const { t } = useTranslation();

    return (
        <section className='final-cta-section'>
            <div className='final-cta-content'>
                <h2>{t('finalCta.title')}</h2>
                <p className='font-tomorrow'>{t('finalCta.description')}</p>
                <div className='final-cta-buttons'>
                    <button className='btn-primary' onClick={() => window.location.href='/lien-he'}>
                        {t('finalCta.contact')}
                    </button>
                    <button className='btn-secondary' onClick={() => window.location.href='/lien-he'}>
                        {t('finalCta.partner')}
                    </button>
                </div>
            </div>
        </section>
    );
}

export default SectionFinalCTA;
